import React from 'react';

function ProductCard({ product, onClick }) {
  const { 
    product_id, 
    name, 
    salt_composition, 
    mrp, 
    manufacturers, 
    image_url,
    packaging_detail,
    package: packageType,
    qty,
    product_form,
    inventory_quantity,
    deferred_allowed,
    is_active,
    info_tags
  } = product;

  const mainImage = image_url && image_url.length > 0 ? image_url[0] : null;
  const placeholderImage = "https://pub-22fd78ce20764889a8892ec465765dae.r2.dev/cdnimages/PLACEHOLDER.png";
  
  // Determine inventory status
  const getInventoryStatus = () => {
    if (inventory_quantity === undefined || inventory_quantity === null) return null;

    const isDeferredAllowed = deferred_allowed === undefined || deferred_allowed === null
      ? true
      : Boolean(deferred_allowed);

    const quantity = Number(inventory_quantity);
    if (Number.isNaN(quantity)) return null;

    if (quantity <= 0) {
      return isDeferredAllowed ? 'deferred' : 'out-of-stock';
    }

    return 'instant';
  };
  
  const inventoryStatus = getInventoryStatus();

  const isActive = is_active === undefined || is_active === null
    ? true
    : Boolean(is_active);

  const statusTags = [];

  if (inventoryStatus) {
    statusTags.push({
      key: 'inventory-status',
      type: inventoryStatus,
      label:
        inventoryStatus === 'instant'
          ? 'INSTANT'
          : inventoryStatus === 'deferred'
            ? 'DEFERRED'
            : 'OUT OF STOCK'
    });
  }

  if (isActive) {
    statusTags.push({
      key: 'active',
      type: 'active',
      label: 'ACTIVE'
    });
  } else {
    statusTags.push({
      key: 'inactive',
      type: 'inactive',
      label: 'INACTIVE'
    });
  }

  return (
    <div className="product-card" onClick={onClick}>
      <img 
        src={mainImage || placeholderImage} 
        alt={name} 
        className="product-image"
        onError={(e) => {
          e.target.src = placeholderImage;
        }}
      />
      {statusTags.length > 0 && (
        <div className="inventory-tags">
          {statusTags.map(tag => (
            <div key={tag.key} className={`inventory-tag ${tag.type}`}>
              {tag.label}
            </div>
          ))}
        </div>
      )}
      <div className="product-info">
        <h3>{name}</h3>
        {Array.isArray(info_tags) && info_tags.length > 0 && (
          <div className="info-tags">
            {info_tags.map((tag) => (
              <span key={tag} className="info-tag">
                {tag}
              </span>
            ))}
          </div>
        )}
        <p><strong>Product ID:</strong> {product_id}</p>
        <p><strong>Manufacturer:</strong> {manufacturers}</p>
        <p><strong>Salt Composition:</strong> {salt_composition}</p>
        <p><strong>Packaging:</strong> {packaging_detail || `${qty} ${product_form}`}</p>
        <p className="product-price">₹{mrp}</p>
      </div>
    </div>
  );
}

export default ProductCard; 